import { INITIAL_STATE } from "../../components/GamePlayComponents/constant";
import { ILudoboardState, LBAction } from "../../pages/GamePlay/types";
import { _has, _isNil } from "../../utils/helpers/zupeeLodash";
import {
  INTERNET_CONNECTIVITY,
  LB_FINISH_KILL_USER_TOKEN,
  LB_FINISH_MOVE_USER_TOKEN,
  LB_HIDE_GAME_START_NUDGE,
  LB_HIDE_POINTS_ANIMATION,
  LB_HIDE_SKIP_BOX,
  LB_HIDE_SMOKE_ANIMATION,
  LB_HIDE_TRIPLE_SIX_ANIMATION,
  LB_KILL_USER_TOKEN,
  LB_LEAVE_TABLE,
  LB_MOVE_USER_TOKEN,
  LB_PLAYER_JOIN_TABLE,
  LB_RESET_ALL_CN,
  LB_RESET_GAMEPLAY,
  LB_RESET_SCORE_FLY_ANIMATION_CONFIG,
  LB_ROUND_TIMER_STARTED,
  LB_SET_GAME_TIMER,
  LB_SET_KUKARI_MOVE_CONFIG,
  LB_SET_PLAYER_TCOUNT,
  LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE,
  LB_SET_REACH_HOME_CN,
  LB_SET_SAFE_CN,
  LB_SET_SCORE_FLY_ANIMATION_CONFIG,
  LB_SET_SHOW_TAKE_HOME_NUDGE,
  LB_SET_SKIP_COUNT_FOR_NUDGE,
  LB_SET_TOKEN_CUT_CN,
  LB_SHOW_GAME_START_NUDGE,
  LB_SHOW_GAME_TIME_NUDGE,
  LB_SHOW_POINTS_ANIMATION,
  LB_SHOW_SKIP_BOX,
  LB_SHOW_SMOKE_ANIMATION,
  LB_SHOW_TRIPLE_SIX_ANIMATION,
  LB_SHOW_WRONG_TURN_ALERT,
  LB_START_BOUNCE_ANIMATION,
  LB_START_DICE_ANIMATION,
  LB_STOP_BOUNCE_ANIMATION,
  LB_STOP_DICE_ANIMATION,
  LB_STOP_TURN_TIMER,
  LB_TOGGLE_COIN_ANIMATION,
  LB_TOGGLE_LAST_MOVE,
  LB_UPDATE_PLAYER_SI_MAP,
  LB_UPDATE_TABLE_INFO,
  LB_USER_PROFILE_FOLLOW,
  LB_USER_PROFILE_SET,
  LB_USER_TURN_STARTED,
  SET_RANK_DATA,
  LB_SET_IS_TNC_BS_VISIBLE,
  LB_START_TIME_BANK_TIMER,
  LB_STOP_TIME_BANK_TIMER,
  LB_UPDATE_TIME_BANK_TIME_LEFT,
  LB_SHOW_GAME_END_NUDGE,
  LB_HIDE_GAME_END_NUDGE,
  LB_NX_SHOW_KUKARI_SCORE,
  LB_NX_HIDE_KUKARI_SCORE,
  LB_NX_SHOW_SCORE_REVEAL_ANIMATION,
  LB_NX_HIDE_SCORE_REVEAL_ANIMATION,
  LB_SET_SHOW_EXTRA_MOVE_NUDGE,
  LB_SET_IS_SKIP_TOOLTIP_VISIBLE,
} from "../reduxConstants";

function ludoboardReducer(
  state: ILudoboardState = INITIAL_STATE,
  action: LBAction
): ILudoboardState {
  switch (action.type) {
    case LB_PLAYER_JOIN_TABLE: {
      return { ...state, tableInfo: { ...state.tableInfo, pi: action.pi } };
    }
    case LB_UPDATE_TABLE_INFO: {
      return { ...state, tableInfo: { ...state.tableInfo, ...action.updates } };
    }
    case LB_UPDATE_PLAYER_SI_MAP: {
      return { ...state, tableInfo: { ...state.tableInfo, ...action.updates } };
    }
    case LB_USER_TURN_STARTED: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          ...action.payload,
          resetTimer: (state.tableInfo.resetTimer || 0) + 1,
        },
      };
    }
    case LB_ROUND_TIMER_STARTED: {
      return { ...state, tableInfo: { ...state.tableInfo, ...action.payload } };
    }
    case LB_START_DICE_ANIMATION: {
      return { ...state, tableInfo: { ...state.tableInfo, startDice: true } };
    }
    case LB_STOP_DICE_ANIMATION: {
      return { ...state, tableInfo: { ...state.tableInfo, startDice: false } };
    }
    case LB_START_BOUNCE_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, bounceAnimation: true },
      };
    }
    case LB_STOP_BOUNCE_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, bounceAnimation: false },
      };
    }
    case LB_SHOW_TRIPLE_SIX_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, tripleSixAnimation: true },
      };
    }
    case LB_HIDE_TRIPLE_SIX_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, tripleSixAnimation: false },
      };
    }
    case LB_SET_GAME_TIMER: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, gameTimer: action.gameTimer },
      };
    }
    case LB_MOVE_USER_TOKEN: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, movingKukari: action.movingKukari },
      };
    }
    case LB_FINISH_MOVE_USER_TOKEN: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          pi: action.pi,
          movingKukari: action.movingKukari,
        },
      };
    }
    case LB_KILL_USER_TOKEN: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, killedKukari: action.killedKukari },
      };
    }
    case LB_SHOW_SMOKE_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, smoke: action.smoke },
      };
    }
    case LB_HIDE_SMOKE_ANIMATION: {
      return { ...state, tableInfo: { ...state.tableInfo, smoke: null } };
    }
    case LB_FINISH_KILL_USER_TOKEN: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          pi: action.pi,
          killedKukari: action.killedKukari,
        },
      };
    }
    case LB_SHOW_SKIP_BOX: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          showSkipBox: true,
          skipSi: action.skipSi,
        },
      };
    }
    case LB_HIDE_SKIP_BOX: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showSkipBox: false },
      };
    }
    case LB_SET_PLAYER_TCOUNT: {
      return { ...state, tableInfo: { ...state.tableInfo, pi: action.pi } };
    }
    case LB_TOGGLE_COIN_ANIMATION: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          coinAnimation: !state.tableInfo.coinAnimation,
        },
      };
    }
    case LB_SHOW_POINTS_ANIMATION: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          homeAnimationConfig: action.homeAnimationConfig,
        },
      };
    }
    case LB_HIDE_POINTS_ANIMATION: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, homeAnimationConfig: null },
      };
    }
    case LB_SHOW_WRONG_TURN_ALERT: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          showWrongTurnAlert: action.showWrongTurnAlert,
        },
      };
    }
    case LB_TOGGLE_LAST_MOVE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          finalMovePlayers: action.finalMovePlayers,
        },
      };
    }
    case LB_LEAVE_TABLE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          pi: action.pi,
          leftPlayers: action.leftPlayers,
        },
      };
    }
    case LB_USER_PROFILE_SET: {
      return {
        ...state,
        userProfile: { ...state.userProfile, [action.zuid]: action.data },
      };
    }
    case LB_USER_PROFILE_FOLLOW: {
      const zuid = action?.userProfile?.user?.zupeeUserId;
      if (_has(state?.userProfile, zuid)) {
        return {
          ...state,
          userProfile: {
            ...state?.userProfile,
            [zuid]: {
              ...state?.userProfile?.[zuid],
              user: {
                ...state?.userProfile?.[zuid]?.user,
                ...(action?.userProfile?.user || {}),
              },
              buttonCta:
                action?.userProfile?.buttonCta ||
                state?.userProfile?.[zuid]?.buttonCta,
            },
          },
        };
      }
      return state;
    }
    case LB_STOP_TURN_TIMER: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showTurnTimer: false },
      };
    }
    case INTERNET_CONNECTIVITY: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, internetConnectivity: action.status },
      };
    }
    // case SET_RANK_DATA: {
    //   return {
    //     ...state,
    //     tableInfo: { ...state.tableInfo, rankData: action.rankData },
    //   };
    // }
    case LB_SHOW_GAME_TIME_NUDGE: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showGameTimeNudge: true },
      };
    }
    case LB_SHOW_GAME_START_NUDGE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          showGameStartNudge: true,
          isScoreRevealAnimationVisible: false,
          isKukariScoreVisible: false,
        },
      };
    }
    case LB_HIDE_GAME_START_NUDGE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          showGameStartNudge: false,
        },
      };
    }
    case LB_SHOW_GAME_END_NUDGE: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showGameEndNudge: true, movesLeft: 0 },
      };
    }
    case LB_HIDE_GAME_END_NUDGE: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showGameEndNudge: false },
      };
    }
    case LB_SET_SHOW_TAKE_HOME_NUDGE: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, showTakeHomeNudge: action.value },
      };
    }
    case LB_SET_KUKARI_MOVE_CONFIG: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          kukariMoveConfig: action.kukariMoveConfig,
        },
      };
    }
    case LB_SET_SKIP_COUNT_FOR_NUDGE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          skipCountForNudge: action.skipCountForNudge,
        },
      };
    }
    case LB_SET_TOKEN_CUT_CN: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, tokenCutCN: action.cnData },
      };
    }
    case LB_SET_REACH_HOME_CN: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, reachHomeCN: action.cnData },
      };
    }
    case LB_SET_SAFE_CN: {
      return {
        ...state,
        tableInfo: { ...state.tableInfo, safeCN: action.cnData },
      };
    }
    case LB_RESET_ALL_CN: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          tokenCutCN: [],
          reachHomeCN: [],
          safeCN: [],
        },
      };
    }
    case LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isPrizepoolTooltipVisible: action.isPrizepoolTooltipVisible,
        },
      };
    }
    case LB_SET_IS_TNC_BS_VISIBLE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isTNCBSVisible: action.isTNCBSVisible,
        },
      };
    }
    case LB_NX_SHOW_KUKARI_SCORE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isKukariScoreVisible: true,
        },
      };
    }
    case LB_NX_HIDE_KUKARI_SCORE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isKukariScoreVisible: false,
        },
      };
    }
    case LB_NX_SHOW_SCORE_REVEAL_ANIMATION: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isScoreRevealAnimationVisible: true,
          isKukariScoreVisible: false,
        },
      };
    }
    case LB_NX_HIDE_SCORE_REVEAL_ANIMATION: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isScoreRevealAnimationVisible: false,
          isKukariScoreVisible: false,
        },
      };
    }
    case LB_SET_SCORE_FLY_ANIMATION_CONFIG: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          scoreFlyAnimationConfig: {
            ...state.tableInfo.scoreFlyAnimationConfig,
            [action.scoreFlyAnimationConfig.playerNumber]:
              action.scoreFlyAnimationConfig,
          },
        },
      };
    }
    case LB_RESET_SCORE_FLY_ANIMATION_CONFIG: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          kukariMoveConfig: null,
          scoreFlyAnimationConfig: {
            ...state.tableInfo.scoreFlyAnimationConfig,
            [action.playerNumber]: null,
          },
        },
      };
    }
    case LB_START_TIME_BANK_TIMER: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          timeBankTimeLeft: action.timeBankTimeLeft,
          isTimeBankVisible: true,
        },
      };
    }
    case LB_STOP_TIME_BANK_TIMER: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isTimeBankVisible: false,
          timeBankTimeLeft: !_isNil(action.timebankTimeLeft)
            ? action.timebankTimeLeft
            : state.tableInfo.timeBankTimeLeft,
        },
      };
    }
    case LB_UPDATE_TIME_BANK_TIME_LEFT: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          timeBankTimeLeft: action.timeBankTimeLeft,
        },
      };
    }
    case LB_SET_SHOW_EXTRA_MOVE_NUDGE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          showExtraMoveNudge: action.shouldShow,
        },
      };
    }
    case LB_SET_IS_SKIP_TOOLTIP_VISIBLE: {
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          isSkipTooltipVisible: action.isSkipTooltipVisible,
        },
      };
    }
    case LB_RESET_GAMEPLAY: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}

export default ludoboardReducer;
